import React, { useState, useEffect } from 'react'

import { TextInput } from './text-input'
import { ExplicitChangeTextInput } from './explicit-change-text-input'
import { Button } from './button'

import { useStyles } from './list-input.style'

export const ListInput = function ({ size, label, fields = [], values = [], explicitChange = false, onChange = () => {} }) {
  const classes = useStyles()

  const [editingValues, setEditingValues] = useState(setupEditingValues(values))

  useEffect(() => {
    setEditingValues(setupEditingValues(values))
  }, [values])

  function callOnChange (updated) {
    onChange(updated.filter(isRowPopulated))
  }

  const Input = explicitChange ? ExplicitChangeTextInput : TextInput

  function setupEditingValues (values) {
    const editingValues = [ ...values ]
    // Tack on a new row if there are no rows yet or if the last row is populated
    if (editingValues.length === 0 || isRowPopulated(editingValues[editingValues.length - 1])) {
      editingValues.push(buildNewRow())
    }
    return editingValues
  }

  function handleFieldChange (index, key, value) {
    let updated = editingValues.map((v, i) => (index === i) ? { ...v, [key]: value } : { ...v })
    callOnChange(updated)
  }

  function handleDeleteRow (index) {
    const updated = editingValues.filter((v, i) => i !== index)
    callOnChange(updated)
  }

  function buildNewRow () {
    return fields.reduce((newRow, { key }) => ({ ...newRow, [key]: '' }), {})
  }

  function isRowPopulated (row) {
    return !!fields.find(({ key }) => row[key] !== '' && row[key] !== undefined)
  }

  return (
    <label>
      <div className={(size === 'medium') ? 'form-element-label-medium' : 'form-element-label'}>{label}</div>
      <div>
        {editingValues.map((row, index) => (
          <div key={index} className="flex-row">
            {fields.map(({ key, label }) => (
              <div key={key} className={classes.field} data-qa={'list-input-' + key}>
                <Input size={size} value={row[key]} placeholder={label} onChange={(event) => {
                  handleFieldChange(index, key, event.target.value)
                }} />
              </div>
            ))}
            <div className="flex-row">
              {isRowPopulated(row)
                ? (
                  <Button
                    className={classes.deleteAction}
                    variant="icon-secondary"
                    iconClass="font-icon-trash"
                    tooltipLabel="Delete"
                    onClick={() => { handleDeleteRow(index) }}
                  />
                )
                : <div className={classes.deleteSpacer} />
              }
            </div>
          </div>
        ))}
      </div>
    </label>
  )
}
